// @flow
export const noopAction = () => ({
  type: "NOOP_ACTION",
})



// WEBPACK FOOTER //
// ./src/common/redux/actions.js